// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-select .vs__dropdown-toggle[data-v-0297f176],.custom-select .vs__open-indicator[data-v-0297f176]{border:none}a[data-v-0297f176]{text-decoration:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
